// src/Component/Routing/LegacyGalleryRedirect.jsx
import { Navigate, useParams } from "react-router-dom";
export default function LegacyGalleryRedirect({ defaultLang = "fa" }) {
  const { id } = useParams();
  return <Navigate to={`/${defaultLang}/gallery/${id}`} replace />;
}
